<div class="admin-sheets" [class.locked]="isLocked">
  @if (selectedSheet) {
    <div class="sheet">
      <span class="sheet__title">
        <button class="mr-5 t-btn" (click)="selectedSheet = null">
          <i class="fa fa-arrow-left"></i>
        </button>
        {{ selectedSheet.name }}
        <button class="t-btn" (click)="fetchSheets()"><i class="fa fa-rotate-left"></i></button>
      </span>

      <div class="sheet__body">
        @if (selectedTab) {
          <div class="sheet__cells">
            <div *ngFor="let rowValues of selectedTab.content; index as row" class="sheet__cells-row">
              <span>{{ row + 1 }}</span>
              <ng-container *ngFor="let val of rowValues; index as col">
                <div class="sheet__cells-value" *ngIf="showCol(row, col)" [class.exp]='isDropValue(col, rowValues)'>
                  @if (isDropValue(col, rowValues)) {
                    <select (change)="linkOptionChanged($event, row, col)" >
                      <option >LVAR</option>
                      <option *ngFor="let linkOption of getLinkOptions(row, col)" [value]="linkOption.id" [selected]="getSubVarLinkedValue(row, col) == linkOption.id">{{linkOption.name}}</option>
                    </select>
                    <input  (change)="changeValue($event, row + 1, col + 1)"  *ngIf="getSubVarLinkedValue(row, col)" [value]="getSubVarExp(row, col)"
                     type="text" placeholder="EXP" class="exp-inpt" />
                  }

                  <input type="text"  [value]="val" (change)="changeValue($event, row + 1, col + 1)" 
                  [disabled]="lockedCols.has(col) || col % 2 == 0 || getSubVarLinkedValue(row, col)" />
                </div>
              </ng-container>
            </div>
          </div>
        } @else {
          <span>Please selected a tab</span>
        }
      </div>
      <div class="sheet__tabs">
        <button [class.active]="sheetTab?.id == selectedTab?.id" *ngFor="let sheetTab of selectedSheet?.adminSheetTabs" (click)="selectedTab = sheetTab">
          {{ sheetTab.name }}
          <button (click)="deleteSheetTab(sheetTab.id)" class="t-btn"><i class="fa fa-trash"></i></button>
        </button>
      </div>
      <!-- <div class="create-tab">
        <input type="text" placeholder="New Sheet Tab Name" [(ngModel)]="newSheetTab.name" class="form-control w-25" />

        <button class="t-btn" (click)="createNewSheetTab()">+ Create</button>
      </div> -->
    </div>
  } @else {
    <!-- <div class="admin-sheets__create-sheet">
      <input type="text" placeholder="New Sheet Name" [(ngModel)]="newSheet.name" class="form-control w-25" />
      <div>
        For:
        <select (change)="newSheet.opt = $event.target.value">
          <option>Select Sheet's Purpose</option>
          <option *ngFor="let opt of ['estimator']" [value]="opt">{{ opt }}</option>
        </select>
      </div>
      <button class="t-btn" (click)="createNewSheet()">+ Create</button>
    </div>
    <div *ngIf="newSheet.opt == 'estimator'" class="d-flex flex-wrap my-3" style="gap: 0.5rem">
      Select a SubCategory:

      <ng-container *ngFor="let cat of subCategories">
        <button *ngIf="cat.hasVariableBooking" class="btn btn-sm btn-outline-secondary" [class.active]="newSheet.linkedResourceId == 'CATEGORY-' + cat.categorieChildId" (click)="selectSubcatForEstimator(cat)">
          {{ cat.categoryName }}
        </button>
      </ng-container>

      <ng-container *ngFor="let type of typeOfSelectedCategory">
        <button *ngIf="type.hasVariableBooking" class="btn btn-sm btn-outline-secondary" [class.active]="newSheet.linkedResourceId == 'TYPE-' + type.id" (click)="selectTypeForEstimator(type)">
          {{ type.name }}
        </button>
      </ng-container>
    </div> -->
    <div class="admin-sheets__sheet-list">
      <button *ngFor="let sheet of sheets" class="sheet-btn" (click)="selectedSheet = sheet; selectedTab = selectedSheet?.adminSheetTabs?.at(0)">
        <i class="fa-solid fa-scroll"></i>
        {{ sheet.name }}
        <button class="t-btn ml-3" (click)="$event.stopPropagation(); deleteSheet(sheet)"><i class="fa fa-trash"></i></button>
      </button>
    </div>
    <div *ngIf="!sheets?.length" class="no-sheet">No Sheets Created</div>
  }
</div>
